import { z } from 'zod'

export const confirmDetailsSchema = z
    .object({
        badgeNumber: z.string().optional(),
        noBadge: z.boolean().default(false),
        busHubCode: z.string().nonempty(),
        dutyCode: z.string().optional(),
        noDuty: z.boolean().default(false),
    })
    .superRefine((data, ctx) => {
        if (data['badgeNumber']?.trim() === '' && data.noBadge === false) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Check your badge number',
                path: ['badgeNumber'],
            })
        }

        if (!data['dutyCode'] && data.noDuty === false) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Check your duty',
                path: ['dutyCode'],
            })
        }
    })
